export default "__VITE_ASSET__B7bDV$cQ__"